import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";

const WeaScope = Loadable({
  loader: () => import("./Scope"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaScope;



// WEBPACK FOOTER //
// ./ecology9/wea-scope/index.js